import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './SyncSection.css';

function SyncSection() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const [, setCurrentFeature] = useState(0);

  const features = [
    {
      icon: "💬",
      title: "Confident Communication",
      description: "Master the art of expressing ideas clearly  in any situation.",
      color: "#4F46E5"
    },
{
  icon: "💼",
  title: "Career Advancement",
  description: "Unlock new opportunities and climb the ladder with confidence ",
  color: "#059669"
},

    {
      icon: "🌍",
      title: "Cultural Integration",
      description: "Connect deeply across cultures through authentic communication.",
      color: "#DC2626"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % features.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="sync-section">
      <div className="parallax-bg"></div>
      <div className="content-container">
        <div className={`modern-content ${inView ? 'animate' : ''}`} ref={ref}>
          
          {/* Hero Section */}
          <div className="Sync-hero-section">
           
            <h1 className="Sync-hero-title">
              Why Do We <span className="Sync-gradient-text">Do It?</span>
            </h1>
            <p className="Sync-hero-subtitle">
              Speak Bold. Think Bold. <strong>Be Bold.</strong>
            </p>
          </div>

          {/* Mission Statement */}
          <div className="mission-card">
            <div className="mission-icon">🎯</div>
            <p className="mission-text">
              Empowering college students to communicate their thoughts boldly, naturally, and fluently – just like a native speaker. We help them succeed in interviews, workplaces, and everyday life by unlocking NEW opportunities.
            </p>
          </div>

          {/* Interactive Features */}
          <div className="sync-features-showcase">
  <h3 className="sync-features-title">What You'll Master</h3>
  <div className="sync-features-game-row">
    {features.map((feature, index) => (
      <div 
        key={index}
        className="sync-feature-card-game"
        style={{ '--feature-color': feature.color }}
      >
        <div className="sync-feature-icon">{feature.icon}</div>
        <h4 className="sync-feature-title">{feature.title}</h4>
        <p className="sync-feature-description">{feature.description}</p>
      </div>
    ))}
  </div>
</div>





        
          

        </div>
      </div>
    </section>
  );
}

export default SyncSection;